@if (!roouterPath) {
  <form #executionListForm="ngForm">
    @if (!this.disableOfflineButton) {
      <div fxLayout="row">
        <div class="main-container small-layout">
          <div class="lead-text centerText">
            <p [innerHtml]="'landing.main' | translate | safe: 'html'"> </p>
          </div>
          <div fxLayout="row" class="block-option-highlights">
            @if (showAir) {
              <mat-card class="card" (click)="onSelectionOption(isAir)" routerLinkActive="router-link-active"  appMaterialElevation >
                <mat-card-content class="pointerHand">
                  <div class="action-floating info-badge" fxHide.lt-md
                    matTooltip="{{ 'menu.protocol.info' | translate }}">
                    <!--  <mat-icon color="accent">info</mat-icon> -->
                  </div>
                  <img class="icon" src="assets/img/q_air.png"
                    alt="{{ 'menu.manage' | translate }} {{ 'menu.execution' | translate }}">
                  <span class="subtitle">{{ 'menu.air' | translate }}</span>
                </mat-card-content>
              </mat-card>
            }
            @if (showThermal) {
              <mat-card class="card" (click)="onSelectionOption(isThermal)" routerLinkActive="router-link-active" appMaterialElevation >
                <mat-card-content class="pointerHand">
                  <div class="action-floating info-badge" fxHide.lt-md
                    matTooltip="{{ 'menu.protocol.info' | translate }}">
                    <!-- <mat-icon color="accent">info</mat-icon>-->
                  </div>
                  <img class="icon" src="assets/img/q_thermal.png"
                    alt="{{ 'menu.manage' | translate }} {{ 'menu.execution' | translate }}">
                  <span class="subtitle">{{ 'menu.thermal' | translate }}</span>
                </mat-card-content>
              </mat-card>
            }
            @if (showCalibrates) {
              <mat-card class="card" (click)="onSelectionOption(isCalibrates)" routerLinkActive="router-link-active" appMaterialElevation>
                <mat-card-content class="pointerHand">
                  <div class="action-floating info-badge" fxHide.lt-md
                    matTooltip="{{ 'menu.protocol.info' | translate }}">
                    <!--  <mat-icon color="accent">info</mat-icon>-->
                  </div>
                  <img class="icon" src="assets/img/q_calibrates.png"
                    alt="{{ 'menu.manage' | translate }} {{ 'menu.execution' | translate }}">
                  <span class="subtitle">{{ 'menu.calibrates' | translate }}</span>
                </mat-card-content>
              </mat-card>
            }
            <mat-card class="card" style="opacity: 0.5; pointer-events: none;">
              <mat-card-content class="pointerHand">
                <div class="action-floating info-badge" fxHide.lt-md
                  matTooltip="{{ 'menu.protocol.info' | translate }}">
                  <!--  <mat-icon color="accent">info</mat-icon>-->
                </div>
                <img class="icon" src="assets/img/q_qualificates.png"
                  alt="{{ 'menu.manage' | translate }} {{ 'menu.execution' | translate }}">
                <span class="subtitle">{{ 'menu.qualificates' | translate }}</span>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        @if (timestampt) {
          <div class="generatedDate">
            {{ 'home.appVersion' | translate: {version: timestampt} }}
          </div>
        }
      </div>
    }
  </form>
}
